/* eslint-disable react/display-name */
import React from 'react'
import UnitSelectionProvider, {
  UnitSelectionContext,
} from './UnitSelectionContext'
import DatePickerProvider, { DatePickerContext } from './DatePickerContext'
import ContextReducer from './ContextReducer'
import SpinContext, { SpinContextProvider } from './SpinContext'
import ErrorContext, { ErrorContextProvider } from './ErrorContext'
import ErrorBountry from 'core/component/ErrorBoundary'
import ClientContextProvider, { ClientContext } from './ClientContext'
import { MarginAnalysisProvider } from './../marginanalysis/MarginAnalysisContext'
import PNodeZoneContext, { PNodeZoneContextProvider } from './PNodeZoneContext'
import FilterContext, { FilterContextProvider } from './FilterContext'
import JcTmpErrorContext, {
  JcTmpErrorContextProvider,
} from './JcTmpErrorContext'
import GadsGridContextProvider from './GadsGridContext'
import DataContext, { DataContextProvider } from './DataContext'

export default ({ children }) => (
  <ErrorBountry>
    <ContextReducer>
      {({
        targetInfo,
        transDate,
        // setDate,
        // endDate,
        // setEndDate,
        units,
        initLoadingDataStatus,
        unitLoadingStatus,

        unitNameMap,
        setPNodeZoneList,
        pnodeZoneList,
        userName,
        CLIENT,
        loadDateData,
      }) => (
        <ClientContextProvider
          targetInfo={targetInfo}
          userName={userName}
          CLIENT={CLIENT}
        >
          <FilterContextProvider>
            <GadsGridContextProvider>
              <SpinContextProvider
                initLoadingDataStatus={initLoadingDataStatus}
                unitLoadingStatus={unitLoadingStatus}
              >
                <ErrorContextProvider>
                  <UnitSelectionProvider>
                    <DatePickerProvider>
                      <PNodeZoneContextProvider
                        targetInfo={targetInfo}
                        units={units}
                        unitNameMap={unitNameMap}
                        setPNodeZoneList={setPNodeZoneList}
                        pnodeZoneList={pnodeZoneList}
                        selectedDate={transDate}
                        CLIENT={CLIENT}
                      >
                        <MarginAnalysisProvider loadDateData={loadDateData}>
                          <DataContextProvider>
                            <JcTmpErrorContextProvider>
                              {children}
                            </JcTmpErrorContextProvider>
                          </DataContextProvider>
                        </MarginAnalysisProvider>
                      </PNodeZoneContextProvider>
                    </DatePickerProvider>
                  </UnitSelectionProvider>
                </ErrorContextProvider>
              </SpinContextProvider>
            </GadsGridContextProvider>
          </FilterContextProvider>
        </ClientContextProvider>
      )}
    </ContextReducer>
  </ErrorBountry>
)

export {
  UnitSelectionContext,
  DatePickerContext,
  ErrorContext,
  SpinContext,
  PNodeZoneContext,
  ClientContext,
  JcTmpErrorContext,
  FilterContext,
  DataContext,
}
